import { css } from '@emotion/react';
import { Link, tokens } from '@hotjar/hotsauce';
import { DetailedList } from './DetailedList';
import type { DetailedListItem } from './DetailedList';

interface Props {
  siteLink: string;
  detailedList: Omit<DetailedListItem, 'siteLink'>;
}

export function PlanChangeListItem({ siteLink, detailedList }: Props): JSX.Element {
  return (
    <>
      <Link
        href={siteLink}
        kind="standalone"
        isExternal
        css={css`
          ${tokens.truncateText()};
          display: block;
        `}
      >
        {siteLink}
      </Link>

      <DetailedList
        siteLink={siteLink}
        headerItems={detailedList.headerItems}
        items={detailedList.items}
        isFirstColumnNarrow={detailedList.isFirstColumnNarrow}
      />
    </>
  );
}
